import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { bindAll } from 'bind-event-listener';
export var WindowLocationContext = /*#__PURE__*/createContext(null);
export var useWindowLocation = function useWindowLocation() {
  var _useState = useState(window.location.href),
    _useState2 = _slicedToArray(_useState, 2),
    location = _useState2[0],
    setLocation = _useState2[1];
  // For easier mocking
  var contextValue = useContext(WindowLocationContext);
  var handleLocationChange = useCallback(function () {
    if (window.location.href !== location) {
      setLocation(window.location.href);
    }
  }, [location, setLocation]);
  useEffect(function () {
    var originalPushState = window.history.pushState;
    var originalReplaceState = window.history.replaceState;
    window.history.pushState = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      originalPushState.apply(this, args);
      handleLocationChange();
    };
    window.history.replaceState = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      originalReplaceState.apply(this, args);
      handleLocationChange();
    };
    var unbind = bindAll(window, [{
      type: 'popstate',
      listener: handleLocationChange
    }]);
    return function () {
      unbind();
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, [handleLocationChange]);
  return contextValue !== null && contextValue !== void 0 ? contextValue : location;
};